module.exports = __webpack_public_path__ + "static/media/konnektivelogo.6fd9932e.png";